/* ad-video-facade.js (10-25-26) - update-safe ad-* asset. Loaded with defer only when the facade renders.
   No network request on load. On click: swaps the button for a youtube-nocookie iframe (autoplay) and fires
   Shopify.analytics.publish('video_play', {video_id, video_title, page_path}) when available. */
(function () {
  'use strict';
  if (window.__adVfBound) return;
  window.__adVfBound = true;
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('.ad-vf__btn') : null;
    if (!btn) return;
    var root = btn.closest('[data-ad-vf]');
    if (!root) return;
    var id = root.getAttribute('data-video-id') || '';
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    var title = root.getAttribute('data-video-title') || 'YouTube video';
    var start = parseInt(root.getAttribute('data-start'), 10) || 0;
    var src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0' + (start > 0 ? '&start=' + start : '');
    var f = document.createElement('iframe');
    f.src = src;
    f.title = title;
    f.width = '640'; f.height = '360';
    f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    btn.replaceWith(f);
    try { f.focus(); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('video_play', { video_id: id, video_title: title, page_path: location.pathname });
      }
    } catch (e) { /* never block playback */ }
  });
})();
